import { UiDownloadButtonModel } from "../../models";

export function mockUiDownloadButtonModel({
    id = "download-button-1234",
    type = "uiDownloadButton",
    locale = "en",
    content = mockUiDownloadButtonModelContent()
}: Partial<UiDownloadButtonModel> = {}): UiDownloadButtonModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiDownloadButtonModelContent = UiDownloadButtonModel["content"];

export function mockUiDownloadButtonModelContent({
    entryTitle = "Example download button",
    text = "Download",
    mediaAsset = {
        id: "asset-1234",
        title: "Example asset",
        url: "#download"
    },
    ...optionals
}: Partial<UiDownloadButtonModelContent> = {}): UiDownloadButtonModelContent {
    return {
        entryTitle,
        text,
        mediaAsset,
        ...optionals
    };
}
